import { render, staticRenderFns } from "./ListItemRound.vue?vue&type=template&id=27f907dd&"
import script from "./ListItemRound.vue?vue&type=script&lang=ts&"
export * from "./ListItemRound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports